module.exports = __webpack_public_path__ + "img/man.a765cd40.png";